export default "__VITE_ASSET__WX$MqrLs__"